import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { useUser } from '../../utils/userContext';
import Select from 'react-select';
import useCountryCodes from '../../utils/useCountryCodes';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';


export default function OnboardProjects() {
    const [projects, setProjects] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [updateShowModal, setUpdateShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [loading, setLoading] = useState(false);
    const { user } = useUser();
    const handleErrors = useHandleErrors();
    const { countryCodes } = useCountryCodes();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredProjects, setFilteredProjects] = useState([]);



    const [statusCounts, setStatusCounts] = useState({
        Onboarded: 0,
        'Gate 1 - Approved': 0,
        'Gate 1 - Rejected': 0,
        'Gate 2 - Approved': 0,
        'Gate 2 - Rejected': 0,
        Active: 0,
        'In Flight': 0,
        'On Hold': 0,
        InActive: 0,
        Assigned: 0,
        Unassigned: 0,
        Closed: 0
    });
    const [formData, setFormData] = useState({
        ProjectName: '',
        ProjectCode: '',
        Type: '',
        ReportingId: '',
        StartDate: '',
        EndDate: '',
        ProjectType: '',
        ProjectStatus: 'Onboarded',
        ClientDetails: '',
        ClientContactDetails: '',
        Description: '',
        ActiveFlag: "Y",
        CreatedBy: user?.FirstName,
        clientContactPrefix: ''

    });

    const ClearIndicator = () => null;

    // Function to get status badge styling - REMOVE pending status cases
    const getStatusBadge = (status) => {
        const statusLower = status.trim().toLowerCase();
        
        if (statusLower === 'onboarded') {
            return <span className="badge border border-info text-info status">
                <i className="ri-file-add-line"></i> {status.trim()}
            </span>;
        } else if (statusLower.includes('gate 1 - approved')) {
            return <span className="badge border border-success text-success status">
                <i className="ri-checkbox-circle-line"></i> {status.trim()}
            </span>;
        } else if (statusLower.includes('gate 1 - rejected')) {
            return <span className="badge border border-danger text-danger status">
                <i className="ri-close-circle-line"></i> {status.trim()}
            </span>;
        } else if (statusLower.includes('gate 2 - approved')) {
            return <span className="badge border border-success text-success status">
                <i className="ri-checkbox-circle-line"></i> {status.trim()}
            </span>;
        } else if (statusLower.includes('gate 2 - rejected')) {
            return <span className="badge border border-danger text-danger status">
                <i className="ri-close-circle-line"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'active') {
            return <span className="badge border border-success text-success status">
                <i className="ri-thumb-up-fill"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'assigned') {  // Added Assigned status badge
            return <span className="badge border border-info text-info status">
                <i className="ri-user-add-line"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'in flight') {
            return <span className="badge border border-primary text-primary status">
                <i className="ri-rocket-line"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'on hold') {
            return <span className="badge border border-dark text-dark status">
                <i className="ri-hand"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'inactive') {
            return <span className="badge border border-secondary text-secondary status">
                <i className="ri-close-circle-line"></i> {status.trim()}
            </span>;
        } else if (statusLower === 'closed') {
            return <span className="badge border border-dark text-dark status">
                <i className="ri-lock-line"></i> {status.trim()}
            </span>;
        } else {
            return <span className="badge border border-light text-light status">
                <i className="ri-question-line"></i> {status.trim()}
            </span>;
        }
    };

    // Function to get next allowed status based on current status - REMOVE pending cases
    const getNextAllowedStatuses = (currentStatus) => {
        const statusLower = currentStatus?.toLowerCase();
        
        let allowedStatuses = [];
        
        switch (statusLower) {
            case 'onboarded':
                allowedStatuses = [
                    { value: 'Onboarded', label: 'Onboarded' },
                    { value: 'Gate 1 - Approved', label: 'Gate 1 - Approved' },
                    { value: 'Gate 1 - Rejected', label: 'Gate 1 - Rejected' },
                    { value: 'InActive', label: 'InActive' }
                ];
                break;
            case 'gate 1 - approved':
                allowedStatuses = [
                    { value: 'Gate 1 - Approved', label: 'Gate 1 - Approved' },
                    { value: 'Gate 2 - Approved', label: 'Gate 2 - Approved' },
                    { value: 'Gate 2 - Rejected', label: 'Gate 2 - Rejected' },
                    { value: 'On Hold', label: 'On Hold' }
                ];
                break;
            case 'gate 1 - rejected':
                allowedStatuses = [
                    { value: 'Gate 1 - Rejected', label: 'Gate 1 - Rejected' },
                    { value: 'Gate 1 - Approved', label: 'Gate 1 - Approved' },
                    { value: 'InActive', label: 'InActive' }
                ];
                break;
            case 'gate 2 - approved':
                allowedStatuses = [
                    { value: 'Gate 2 - Approved', label: 'Gate 2 - Approved' },
                    { value: 'Active', label: 'Active' },
                    { value: 'Assigned', label: 'Assigned' },
                    { value: 'On Hold', label: 'On Hold' }
                ];
                break;
            case 'gate 2 - rejected':
                allowedStatuses = [
                    { value: 'Gate 2 - Rejected', label: 'Gate 2 - Rejected' },
                    { value: 'Gate 2 - Approved', label: 'Gate 2 - Approved' },
                    { value: 'InActive', label: 'InActive' }
                ];
                break;
            case 'active':
                allowedStatuses = [
                    { value: 'Active', label: 'Active' },
                    { value: 'Assigned', label: 'Assigned' },
                    { value: 'In Flight', label: 'In Flight' },
                    { value: 'On Hold', label: 'On Hold' },
                    { value: 'Closed', label: 'Closed' },
                    { value: 'InActive', label: 'InActive' }
                ];
                break;
            case 'assigned':
                allowedStatuses = [
                    { value: 'Assigned', label: 'Assigned' },
                    { value: 'In Flight', label: 'In Flight' },
                    { value: 'Active', label: 'Active' },
                    { value: 'On Hold', label: 'On Hold' },
                    { value: 'Closed', label: 'Closed' }
                ];
                break;
            case 'in flight':
                allowedStatuses = [
                    { value: 'In Flight', label: 'In Flight' },
                    { value: 'Active', label: 'Active' },
                    { value: 'Assigned', label: 'Assigned' },
                    { value: 'On Hold', label: 'On Hold' },
                    { value: 'Closed', label: 'Closed' }
                ];
                break;
            case 'on hold':
                allowedStatuses = [
                    { value: 'On Hold', label: 'On Hold' },
                    { value: 'Active', label: 'Active' },
                    { value: 'Assigned', label: 'Assigned' },
                    { value: 'In Flight', label: 'In Flight' },
                    { value: 'InActive', label: 'InActive' }
                ];
                break;
            case 'closed':
                allowedStatuses = [
                    { value: 'Closed', label: 'Closed' }
                ];
                break;
            case 'inactive':
                allowedStatuses = [
                    { value: 'InActive', label: 'InActive' },
                    { value: 'Onboarded', label: 'Onboarded' }
                ];
                break;
            default:
                allowedStatuses = editStatuses;
        }
        
        return allowedStatuses;
    };

    const getProjects = async () => {
        setLoading(true);
        try {
            const path = "/getProjectDetails";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const formattedProjects = response.data.GetOnboardedProjects.map(project => {
                    // Handle contact details parsing for display
                    let displayContactPrefix = '';
                    let displayContactNumber = project.ClientContactDetails;
                    
                    if (project.ClientContactDetails) {
                        const contactString = project.ClientContactDetails.toString();
                        
                        // Check if it contains a space (already formatted)
                        if (contactString.includes(' ')) {
                            const [prefix, ...numberParts] = contactString.split(' ');
                            displayContactPrefix = prefix;
                            displayContactNumber = numberParts.join(' ');
                        } else {
                            // If no space, keep original for now (will be parsed in edit modal)
                            displayContactNumber = contactString;
                        }
                    }
                    
                    return {
                        ...project,
                        StartDate: moment(project.StartDate).format('YYYY-MM-DD'),
                        EndDate: moment(project.EndDate).format('YYYY-MM-DD'),
                        clientContactPrefix: displayContactPrefix,
                        ClientContactDetails: displayContactNumber
                    };
                });
                setProjects(formattedProjects);

            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    // Handle 404 status code separately
                    setProjects([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    const handleKeyPress = (event) => {
        const charCode = event.charCode || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            getProjects();
            hasFetchedRef.current = true;
        }
    }, []);

    useEffect(() => {
        const counts = projects.reduce((acc, project) => {
            acc[project.ProjectStatus] = (acc[project.ProjectStatus] || 0) + 1;
            return acc;
        }, {});

        setStatusCounts({
            Onboarded: counts['Onboarded'] || 0,
            'Gate 1 - Approved': counts['Gate 1 - Approved'] || 0,
            'Gate 1 - Rejected': counts['Gate 1 - Rejected'] || 0,
            'Gate 2 - Approved': counts['Gate 2 - Approved'] || 0,
            'Gate 2 - Rejected': counts['Gate 2 - Rejected'] || 0,
            Active: counts['Active'] || 0,
            'In Flight': counts['In Flight'] || 0,
            'On Hold': counts['On Hold'] || 0,
            InActive: counts['InActive'] || 0,
            Assigned: counts['Assigned'] || 0,
            Unassigned: counts['Active'] || 0,
            Closed: counts['Closed'] || 0
            // Removed: Gate 1 - Pending and Gate 2 - Pending
        });
    }, [projects]);

    const handleShow = () => setShowModal(true);
    const handleUpdateClose = () => setUpdateShowModal(false);

    const handleClose = (e) => {
        setShowModal(false)
        setFormData("")
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;
        setSelectedProject({
            ...selectedProject,
            [name]: value
        });
    };

    const handleUpdate = async () => {
        setLoading(true);
        try {
            // Properly combine country code and phone number
            let contactNumber = '';
            if (selectedProject?.clientContactPrefix && selectedProject?.ClientContactDetails) {
                // Extract the country code from the prefix (remove the index part)
                const countryCode = selectedProject.clientContactPrefix.split('-')[0];
                // Save as concatenated format (no space) to match existing data format
                contactNumber = `${countryCode.replace('+', '')}${selectedProject.ClientContactDetails}`;
            } else if (selectedProject?.ClientContactDetails) {
                // If no country code selected, just use the phone number
                contactNumber = selectedProject.ClientContactDetails;
            }
            
            const updatedProject = {
                ...selectedProject,
                ProjectCode: selectedProject.ProjectCode,
                ClientContactDetails: contactNumber
            };
            
            const path = "/updateOnboardProject";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.put(URL, updatedProject, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            
            if (response.status === 200) {
                console.log('Project updated successfully:');
                setUpdateShowModal(false);
                getProjects();
                toast.success("Project updated successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    // Update the handleUpdateShow function to properly parse concatenated contact details
    const handleUpdateShow = (project) => {
        console.log("Original project contact:", project.ClientContactDetails);
        
        // Parse the client contact details to separate country code and number
        let parsedContactPrefix = '';
        let parsedContactNumber = '';
        
        if (project.ClientContactDetails) {
            const contactString = project.ClientContactDetails.toString();
            
            // Try to find a matching country code from the beginning of the string
            let matchingCountryCode = null;
            let matchingIndex = -1;
            
            // Sort country codes by length (longest first) to match the most specific code
            const sortedCodes = [...Codes].sort((a, b) => {
                const aValue = a.value.replace('+', '');
                const bValue = b.value.replace('+', '');
                return bValue.length - aValue.length;
            });
            
            for (let i = 0; i < sortedCodes.length; i++) {
                const code = sortedCodes[i];
                const codeValue = code.value.replace('+', ''); // Remove + if present
                
                if (contactString.startsWith(codeValue)) {
                    matchingCountryCode = code;
                    // Find the original index in the unsorted array
                    matchingIndex = Codes.findIndex(c => c.value === code.value);
                    break;
                }
            }
            
            if (matchingCountryCode && matchingIndex !== -1) {
                const codeValue = matchingCountryCode.value.replace('+', '');
                parsedContactPrefix = `${matchingCountryCode.value}-${matchingIndex}`;
                parsedContactNumber = contactString.substring(codeValue.length);
            } else {
                // If no matching country code found, treat the whole thing as phone number
                parsedContactNumber = contactString;
            }
        }
        
        console.log("Parsed prefix:", parsedContactPrefix);
        console.log("Parsed number:", parsedContactNumber);
        
        // Set the selected project with parsed contact details
        setSelectedProject({
            ...project,
            ProjectStatus: project.ProjectStatus || 'Onboarded',
            clientContactPrefix: parsedContactPrefix,
            ClientContactDetails: parsedContactNumber
        });
        setUpdateShowModal(true);
    };


    const handleSubmit = async () => {
        setLoading(true);
        if (!formData.ProjectName) {
            toast.error("Project Name is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.ProjectCode) {
            toast.error("Project Code is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.Type) {
            toast.error("Type is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.ReportingId) {
            toast.error("Reporting Id is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.StartDate) {
            toast.error("Start Date is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.EndDate) {
            toast.error("End Date is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.ProjectStatus) {
            toast.error("Status is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.ClientDetails) {
            toast.error("Client Details is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (!formData.Description) {
            toast.error("Description is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        try {
            const path = "/onboardProject";
            const URL = process.env.REACT_APP_BE_URL + path;
            // Save contact number in concatenated format (no space)
            const contactNumber = formData.clientContactPrefix ? 
                `${formData.clientContactPrefix.split('-')[0].replace('+', '')}${formData.ClientContactDetails}` : 
                formData.ClientContactDetails;
            
            const dataToSend = {
                ...formData,
                ProjectType: formData.Type,
                ClientContactDetails: contactNumber,
                ActiveFlag: "Y",
                CreatedBy: user?.FirstName,
            };
            const response = await axios.post(URL, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                console.log('Project onboarded successfully:', response);
                handleClose();
                toast.success("Project onboarded successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setFormData("")
                getProjects();
            } else {
                handleErrors(response);
            }
        }
        catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }

    };

    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(projects);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Projects');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Projects_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Projects List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(projects);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Projects');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(data, `WW360-Projects_Report_${formattedDate}.xlsx`);
    };

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredProjects(
            projects.filter(project =>
                project.ProjectCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
                project.ProjectName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                project.ClientDetails.toLowerCase().includes(searchQuery.toLowerCase()) ||
                project.ProjectStatus.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, projects]);

    const shareData = {
        title: 'Projects List',
        text: 'Check out the Projects list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };


    const types = [
        { value: 'General & Administration', label: 'General & Administration' },
        { value: 'IT Projects', label: 'IT Projects' },
        { value: 'Business Projects', label: 'Business Projects' },
        { value: 'Marketing Projects', label: 'Marketing Projects' },
        { value: 'Research and Development (R&D)', label: 'Research and Development (R&D)' },
        { value: 'Financial Projects', label: 'Financial Projects' },
        { value: 'HR Projects', label: 'HR Projects' }
    ];
    // Create separate status arrays for onboard and edit forms - NO PENDING STATUSES
    const onboardStatuses = [
        { value: 'Onboarded', label: 'Onboarded' },
        { value: 'Gate 1 - Approved', label: 'Gate 1 - Approved' },
        { value: 'Gate 1 - Rejected', label: 'Gate 1 - Rejected' },
        { value: 'Gate 2 - Approved', label: 'Gate 2 - Approved' },
        { value: 'Gate 2 - Rejected', label: 'Gate 2 - Rejected' },
        { value: 'Active', label: 'Active' },
        { value: 'InActive', label: 'InActive' },
        { value: 'On Hold', label: 'On Hold' },
        { value: 'In Flight', label: 'In Flight' },
        { value: 'Closed', label: 'Closed' }
    ];

    const editStatuses = [
        { value: 'Onboarded', label: 'Onboarded' },
        { value: 'Gate 1 - Approved', label: 'Gate 1 - Approved' },
        { value: 'Gate 1 - Rejected', label: 'Gate 1 - Rejected' },
        { value: 'Gate 2 - Approved', label: 'Gate 2 - Approved' },
        { value: 'Gate 2 - Rejected', label: 'Gate 2 - Rejected' },
        { value: 'Active', label: 'Active' },
        { value: 'Assigned', label: 'Assigned' },
        { value: 'InActive', label: 'InActive' },
        { value: 'On Hold', label: 'On Hold' },
        { value: 'In Flight', label: 'In Flight' },
        { value: 'Closed', label: 'Closed' }
    ];

    const Codes = countryCodes.map((country) => ({
        value: country.value,
        label: `${country.value} (${country.label})`,
    }));

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredProjects.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredProjects.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);
    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Projects</h3>
                            <div className="project-cycle-info mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="text-muted mr-2">Project Cycle:</span>
                                    <div className="cycle-steps d-flex align-items-center">
                                        <span className="cycle-step">
                                            <i className="ri-file-add-line text-info"></i> Onboard
                                        </span>
                                        <i className="ri-arrow-right-line mx-2 text-muted"></i>
                                        <span className="cycle-step">
                                            <i className="ri-shield-check-line text-warning"></i> Gate 1
                                        </span>
                                        <i className="ri-arrow-right-line mx-2 text-muted"></i>
                                        <span className="cycle-step">
                                            <i className="ri-shield-star-line text-primary"></i> Gate 2
                                        </span>
                                        <i className="ri-arrow-right-line mx-2 text-muted"></i>
                                        <span className="cycle-step">
                                            <i className="ri-play-circle-line text-success"></i> Active
                                        </span>
                                        <i className="ri-arrow-right-line mx-2 text-muted"></i>
                                        <span className="cycle-step">
                                            <i className="ri-user-add-line text-info"></i> Assigned
                                        </span>
                                        <i className="ri-arrow-right-line mx-2 text-muted"></i>
                                        <span className="cycle-step">
                                            <i className="ri-lock-line text-info"></i> Closed
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-auto">
                            <Button variant="primary" onClick={handleShow}>
                                <i class="ri-add-circle-line"></i> Onboard New
                            </Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 blue">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-file-add-line"></i>
                                        </div>
                                        <h6>{statusCounts['Onboarded']}</h6>
                                    </div>
                                    <span>Onboarded</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 amber">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-shield-check-line"></i>
                                        </div>
                                        <h6>{statusCounts['Gate 1 - Approved'] + statusCounts['Gate 1 - Rejected']}</h6>
                                    </div>
                                    <span>Gate 1</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 purple">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-shield-star-line"></i>
                                        </div>
                                        <h6>{statusCounts['Gate 2 - Approved'] + statusCounts['Gate 2 - Rejected']}</h6>
                                    </div>
                                    <span>Gate 2</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 green">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-thumb-up-line"></i>
                                        </div>
                                        <h6>{statusCounts['Active']}</h6>
                                    </div>
                                    <span>Active</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 info">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-user-add-line"></i>
                                        </div>
                                        <h6>{statusCounts['Assigned']}</h6>
                                    </div>
                                    <span>Assigned</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 blue">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-rocket-line"></i>
                                        </div>
                                        <h6>{statusCounts['In Flight']}</h6>
                                    </div>
                                    <span>In Flight</span>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="card dashboard-card mb-4 dark">
                                <div className="card-body">
                                    <div className="d-flex align-items-top justify-content-between">
                                        <div className="icon icon-box rounded">
                                            <i className="ri-lock-line"></i>
                                        </div>
                                        <h6>{statusCounts['Closed']}</h6>
                                    </div>
                                    <span>Closed</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-5 col-md-8 col-sm-10">
                            <div className="container-fluid row-rounded mb-0">
                                <div className="row px-2 py-0">
                                    <div className="input-group mb-0">
                                        <input
                                            type="search"
                                            className="form-control search-input"
                                            placeholder="Keyword search..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                                                <i className="ri-menu-search-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <small className="form-text text-muted text-center mt-0">
                                <i className="ri-information-2-fill text-info"></i> Allows: Project Name - Project Code - Client Details - Status
                            </small>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body">
                                    {projects?.length === 0 ? (
                                        <div class="container">
                                            <div class="row vh-50 justify-content-center align-items-center">
                                                <div class="col-auto">
                                                    <div class="no-data-wrapper">
                                                        <div class="no-data-found">
                                                            <i class="ri-file-damage-fill"></i>
                                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                                            <p>No Data Found</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div class="row">
                                                <div class="col">
                                                    <h5 class="title mt-1 mb-0">Project Summary</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                    <div class="dropdown-menu dropdown dropdown-menu-right custom-dropdown shadow">
                                                        <div class="row">
                                                            <div class="form-group col-12">
                                                                <label for="costDetails" class="required">Bulk Import <small class="text-muted">(As Excel)</small></label>
                                                                <div class="custom-file">
                                                                    <input type="file" class="custom-file-input" id="uploadEmpofferletter" />
                                                                    <label class="custom-file-label" for="uploadEmpofferletter">Choose file</label>
                                                                </div>
                                                            </div>
                                                            <div class="form-group col-12 my-2">
                                                                <button class="btn btn-link text-danger btn-action" type="button">
                                                                    <i class="ri-delete-bin-6-line"></i>
                                                                </button>
                                                                <a href="#">Download Template</a>
                                                            </div>
                                                            <div class="col-12 text-center">
                                                                <button type="reset" class="btn btn-light" data-toggle="dropdown">Cancel</button>
                                                                <button type="button" class="btn btn-primary" data-toggle="dropdown">Submit <i class="ri-checkbox-circle-line"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Project Name  </th>
                                                                    <th>Project Code  </th>
                                                                    <th>Start Date  </th>
                                                                    <th>End Date  </th>
                                                                    <th>Client Details  </th>
                                                                    <th>Status  </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((project, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{project.ProjectName}</td>
                                                                        <td>{project.ProjectCode}</td>
                                                                        <td>{moment(project.StartDate).format("DD-MM-YYYY")}</td>
                                                                        <td>{moment(project.EndDate).format("DD-MM-YYYY")}</td>
                                                                        <td>{project.ClientDetails}</td>
                                                                        <td>
                                                                            {getStatusBadge(project.ProjectStatus)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <Button variant="link" className="text-info" onClick={() => handleUpdateShow(project)}><i className="ri-list-settings-line"></i></Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* Onboarding Modal */}
                                    <Modal show={showModal} onHide={handleClose} centered size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Onboard Project</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form>
                                                <div className="row">
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="projectName">
                                                        <Form.Label className="text-left d-block required">Project Name</Form.Label>
                                                        <Form.Control type="text" name='ProjectName' value={formData.ProjectName} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="projectCode">
                                                        <Form.Label className="text-left d-block required">Project Code</Form.Label>
                                                        <Form.Control type="text" name='ProjectCode' value={formData.ProjectCode} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="projectType">
                                                        <Form.Label className="text-left d-block required">Type</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="Type"
                                                            value={
                                                                types.find(
                                                                    (option) => option.value === formData.Type
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    Type: selectedOption ? selectedOption.value : "",
                                                                })
                                                            }
                                                            options={types}
                                                            components={{ ClearIndicator }} // Hides the clear indicator
                                                            isClearable
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="reportingID">
                                                        <Form.Label className="text-left d-block required">Reporting ID</Form.Label>
                                                        <Form.Control type="text" name='ReportingId' value={formData.ReportingId} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="startDate">
                                                        <Form.Label className="text-left d-block required">Start Date</Form.Label>
                                                        <Form.Control type="date" name='StartDate' value={formData.StartDate} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="endDate">
                                                        <Form.Label className="text-left d-block required">End Date</Form.Label>
                                                        <Form.Control type="date" name='EndDate' value={formData.EndDate} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="status">
                                                        <Form.Label className="text-left d-block required">Status</Form.Label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="ProjectStatus"
                                                            value={
                                                                onboardStatuses.find(
                                                                    (option) => option.value === formData.ProjectStatus
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    ProjectStatus: selectedOption ? selectedOption.value : "",
                                                                })
                                                            }
                                                            options={onboardStatuses}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="clientDetails">
                                                        <Form.Label className="text-left d-block required">Client Details</Form.Label>
                                                        <Form.Control type="text" name='ClientDetails' value={formData.ClientDetails} onChange={handleChange} required />
                                                    </Form.Group>
                                                    <Form.Group className="col-md-6 col-lg-4" controlId="clientContact">
                                                        <Form.Label className="text-left d-block">Client Contact</Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="clientContactPrefix"
                                                                    value={
                                                                        Codes.find((option) => `${option.value}-${Codes.indexOf(option)}` === formData.clientContactPrefix) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            clientContactPrefix: selectedOption ? selectedOption.value : '',
                                                                        })
                                                                    }
                                                                    options={Codes.map((option, index) => ({
                                                                        ...option,
                                                                        value: `${option.value}-${index}`, // Add the index to make the value unique
                                                                    }))}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                />
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="ClientContactDetails"
                                                                value={formData.ClientContactDetails}
                                                                onChange={(e) =>
                                                                    setFormData({
                                                                        ...formData,
                                                                        ClientContactDetails: e.target.value.replace(formData.clientContactPrefix, '').trim(),
                                                                    })
                                                                }
                                                                onKeyPress={handleKeyPress}
                                                                required
                                                            />
                                                        </InputGroup>
                                                    </Form.Group>

                                                    <Form.Group className="col-md-12 col-lg-12" controlId="description">
                                                        <Form.Label className="text-left d-block required">Description</Form.Label>
                                                        <Form.Control as="textarea" name='Description' rows={3} value={formData.Description} onChange={handleChange} required />
                                                    </Form.Group>
                                                </div>
                                            </Form>
                                        </Modal.Body>
                                        <Modal.Footer className="d-flex justify-content-center">
                                            <Button variant="light" onClick={handleClose}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" onClick={handleSubmit}>
                                                Submit <i class="ri-checkbox-circle-line"></i>
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                    {/* Update Modal */}
                                    <Modal show={updateShowModal} onHide={handleUpdateClose} centered size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Update Project</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <form>
                                                <div className="form-row">
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block" htmlFor="projectName">Project Name</label>
                                                        <input type="text" className="form-control" name="ProjectName" value={selectedProject?.ProjectName || ''} readOnly />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block" htmlFor="projectCode">Project Code</label>
                                                        <input type="text" className="form-control" name="ProjectCode" value={selectedProject?.ProjectCode || ''} readOnly />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block" htmlFor="projectType">Type</label>
                                                        <input type="text" className="form-control" name="Type" value={selectedProject?.Type || ''} readOnly />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block required" htmlFor="reportingID">Reporting ID</label>
                                                        <input type="text" className="form-control" name="ReportingId" value={selectedProject?.ReportingId || ''} onChange={handleUpdateChange} />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block required" htmlFor="startDate">Start Date</label>
                                                        <input type="date" className="form-control" name="StartDate" value={selectedProject?.StartDate || ''} onChange={handleUpdateChange} />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block required" htmlFor="endDate">End Date</label>
                                                        <input type="date" className="form-control" name="EndDate" value={selectedProject?.EndDate || ''} onChange={handleUpdateChange} />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block required" htmlFor="status">Status</label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="ProjectStatus"
                                                            value={
                                                                editStatuses.find(option => option.value === selectedProject?.ProjectStatus) || null
                                                            }
                                                            onChange={selectedOption =>
                                                                setSelectedProject({
                                                                    ...selectedProject,
                                                                    ProjectStatus: selectedOption ? selectedOption.value : '',
                                                                })
                                                            }
                                                            options={getNextAllowedStatuses(selectedProject?.ProjectStatus)}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                        />
                                                        <small className="text-muted mt-1">
                                                            <i className="ri-information-line"></i> Status progression follows project cycle workflow
                                                        </small>
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block required" htmlFor="clientDetails" >Client Details</label>
                                                        <input type="text" className="form-control" name="ClientDetails" value={selectedProject?.ClientDetails || ''} onChange={handleUpdateChange} />
                                                    </div>
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label className="text-left d-block" htmlFor="clientContact" >Client Contact</label>
                                                        <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="clientContactPrefix"
                                                                    value={
                                                                        Codes.find((option, index) => 
                                                                            `${option.value}-${index}` === selectedProject?.clientContactPrefix
                                                                        ) ? {
                                                                            value: selectedProject?.clientContactPrefix,
                                                                            label: (() => {
                                                                                const foundOption = Codes.find((option, index) => 
                                                                                    `${option.value}-${index}` === selectedProject?.clientContactPrefix
                                                                                );
                                                                                return foundOption ? `${foundOption.value} (${foundOption.label.split(' (')[1]}` : '';
                                                                            })()
                                                                        } : null
                                                                    }
                                                                    onChange={(selectedOption) => {
                                                                        if (selectedOption) {
                                                                            setSelectedProject({
                                                                                ...selectedProject,
                                                                                clientContactPrefix: selectedOption.value,
                                                                            });
                                                                        } else {
                                                                            setSelectedProject({
                                                                                ...selectedProject,
                                                                                clientContactPrefix: '',
                                                                            });
                                                                        }
                                                                    }}
                                                                    options={Codes.map((option, index) => ({
                                                                        value: `${option.value}-${index}`,
                                                                        label: `${option.value} (${option.label.split(' (')[1] || option.label})`
                                                                    }))}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    placeholder="Code"
                                                                />
                                                            </div>
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                name="ClientContactDetails" 
                                                                value={selectedProject?.ClientContactDetails || ''} 
                                                                onChange={handleUpdateChange} 
                                                                onKeyPress={handleKeyPress}
                                                                placeholder="Phone number"
                                                            />
                                                        </div>
                                                        <small className="text-muted">
                                                            <i className="ri-information-line"></i> Country code will be automatically prefixed
                                                        </small>
                                                    </div>
                                                    <div className="form-group col-md-12 col-lg-12">
                                                        <label className="text-left d-block required" htmlFor="description">Description</label>
                                                        <textarea className="form-control" name="Description" rows="3" value={selectedProject?.Description || ''} onChange={handleUpdateChange}></textarea>
                                                    </div>
                                                </div>
                                            </form>
                                        </Modal.Body>
                                        <Modal.Footer className="d-flex justify-content-center">
                                            <Button variant="secondary" onClick={handleUpdateClose}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" onClick={handleUpdate}>
                                                Submit <i className="ri-checkbox-circle-line"></i>
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
